export const classArray = (complexClass) => {
  let cls = []
  if (!complexClass) return cls
  if (typeof complexClass === 'string' || Array.isArray(complexClass)) {
    return cls.concat(complexClass)
  }
  if (typeof complexClass === 'object') {
    for (const className in complexClass) {
      if (complexClass[className]) {
        cls.push(className)
      }
    }
  }
  return cls
}
